export const timezones = [
  { id: 1, name: "-12:00" },
  { id: 2, name: "-11:00" },
  { id: 3, name: "-10:00" },
  { id: 4, name: "-09:30" },
  { id: 5, name: "-09:00" },
  { id: 6, name: "-08:00" },
  { id: 7, name: "-07:00" },
  { id: 8, name: "-06:00" },
  { id: 9, name: "-05:00" },
  { id: 10, name: "-04:00" },
  { id: 11, name: "-03:30" },
  { id: 12, name: "-03:00" },
  { id: 13, name: "-02:00" },
  { id: 14, name: "-01:00" },
  { id: 15, name: "±00:00" },
  { id: 16, name: "+01:00" },
  { id: 17, name: "+02:00" },
  { id: 18, name: "+03:00" },
  { id: 19, name: "+03:30" },
  { id: 20, name: "+04:00" },
  { id: 21, name: "+04:30" },
  { id: 22, name: "+05:00" },
  { id: 23, name: "+05:30" },
  { id: 24, name: "+05:45" },
  { id: 25, name: "+06:00" },
  { id: 26, name: "+06:30" },
  { id: 27, name: "+07:00" },
  { id: 28, name: "+08:00" },
  { id: 29, name: "+08:45" },
  { id: 30, name: "+09:00" },
  { id: 31, name: "+09:30" },
  { id: 32, name: "+10:00" },
  { id: 33, name: "+10:30" },
  { id: 34, name: "+11:00" },
  { id: 35, name: "+12:00" },
  { id: 36, name: "+12:45" },
  { id: 37, name: "+13:00" },
  { id: 38, name: "+14:00" },
];
